import {Link} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const BdListLink = (_context: NavigationContext): Link => ({
    type: 'link',
    label: 'navigation.bd_list',
    link: '/bd-tool/list',
    icon: 'navigation-link__list-item',
});